export default __webpack_public_path__ + "static/media/motD3.312c7977.png";